// extracted by mini-css-extract-plugin
export var container = "_dp-0";
export var icon = "_dp-1";
export var text = "_dp-2";